import React from "react";
import "leaflet-geotiff-2";
import "leaflet-geotiff-2/dist/leaflet-geotiff-plotty";
import { GeotiffLayer } from "./GeotiffLayer";
import { palettes } from "../../../common/VisualizationPresets/colorPalettes";
import geoblaze from "geoblaze";
import { connect } from "react-redux";
import { getDownloadLink } from "../../../api/storageApi";
import {
  hideTopography,
  getLegendData,
  setTopographyMapBounds,
} from "../../../redux/actions/legendActions";

function getBoundsFromGeoblazeRaster(raster) {
  if (!raster) return null;
  // geoblaze.load() returns a GeoRaster-like object. Common props: xmin/xmax/ymin/ymax or bbox.
  const xmin = typeof raster.xmin === "number" ? raster.xmin : null;
  const xmax = typeof raster.xmax === "number" ? raster.xmax : null;
  const ymin = typeof raster.ymin === "number" ? raster.ymin : null;
  const ymax = typeof raster.ymax === "number" ? raster.ymax : null;
  if (xmin != null && xmax != null && ymin != null && ymax != null) {
    return [
      [ymin, xmin],
      [ymax, xmax],
    ];
  }

  const bbox = Array.isArray(raster.bbox) ? raster.bbox : null;
  if (bbox && bbox.length >= 4) {
    const [minX, minY, maxX, maxY] = bbox;
    if (
      typeof minX === "number" &&
      typeof minY === "number" &&
      typeof maxX === "number" &&
      typeof maxY === "number"
    ) {
      return [
        [minY, minX],
        [maxY, maxX],
      ];
    }
  }

  return null;
}

class TopographyWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.loadTopographyLegendData = this.loadTopographyLegendData.bind(this);
  }

  async loadTopographyLegendData() {
    const path = this.props.currentCase?.topographyUrl;
    if (!path) {
      return;
    }
    const topographyUrl = await getDownloadLink(path);
    const raster = await geoblaze.load(topographyUrl);
    const topographyBounds = getBoundsFromGeoblazeRaster(raster);
    let maxElevation = ~~geoblaze.max(raster)[0] + 1;
    const minElevation = ~~geoblaze.min(raster)[0] - 1;
    const remainder = (maxElevation - minElevation) % 9;
    maxElevation += 9 - remainder;
    this.props.getLegendData({
      topographyUrl,
      maxElevation,
      minElevation,
      topographyBounds,
    });
  }

  async componentDidMount() {
    if (this.props.currentCase?.topographyUrl) {
      await this.loadTopographyLegendData();
    }
  }

  async componentDidUpdate(prevProps) {
    const prevPath = prevProps.currentCase?.topographyUrl;
    const nextPath = this.props.currentCase?.topographyUrl;
    if (nextPath && prevPath !== nextPath) {
      await this.loadTopographyLegendData();
    }
  }

  componentWillUnmount() {
    if (this.props.topographyVisibility) {
      this.props.hideTopography();
    }
  }

  render() {
    const legendUrl = this.props.topographyUrl;
    const hasResolvedDownloadUrl =
      typeof legendUrl === "string" && legendUrl.length > 0;
    const hasElevationRange =
      this.props.maxElevation != null && this.props.minElevation != null;

    return (
      <>
        {!!this.props.currentCase.topographyUrl &&
          this.props.topographyVisibility &&
          hasResolvedDownloadUrl &&
          hasElevationRange && (
            <GeotiffLayer
              topographyUrl={legendUrl}
              nameOfElevationPallete={this.props.inputElevationPalette}
              maxElevation={this.props.maxElevation}
              minElevation={this.props.minElevation}
              onTopographyMapBounds={this.props.setTopographyMapBounds}
            />
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCase: state.projects.currentCase,
    topographyUrl: state.legend.topographyUrl,
    topographyVisibility: state.legend.topographyVisibility,
    inputElevationPalette:
      state.userSettings?.settings?.visualizationPresets
        ?.inputElevationPalette || palettes.defaults.elevation,
    maxElevation: state.legend.maxElevation,
    minElevation: state.legend.minElevation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTopography: () => dispatch(hideTopography()),
    getLegendData: (payload) => dispatch(getLegendData(payload)),
    setTopographyMapBounds: (payload) =>
      dispatch(setTopographyMapBounds(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopographyWrapper);
